module.exports = __webpack_public_path__ + "img/dianwei_icon.ebd15ea1.svg";